import PropTypes from 'prop-types';
import { Button, Card, Col, FormControl, FormGroup, Row } from 'react-bootstrap';

import './styles.css';

const SimpleSearchComponent = (props) => {
  const { placeholder = 'Search...' } = props;

  const doSearch = (event) => {
    if (event.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Card className="simple-filter admin-search-filter">
      <Card.Body>
        <Row>
          <Col md={8}>
            <FormGroup>
              <FormControl
                onChange={props.onInputChange}
                onKeyPress={doSearch}
                placeholder={placeholder}
                value={props.searchValue}
              />
            </FormGroup>
          </Col>
          <Col className="actions" md={4}>
            <Button
              variant="default"
              className="red-ghost-btn"
              onClick={props.onSearch}
            >
              Search
            </Button>
            <Button
              variant="default"
              className="red-ghost-btn"
              onClick={props.onClear}
            >
              Clear search
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

SimpleSearchComponent.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default SimpleSearchComponent;
